import React from 'react';
import { Transition } from 'react-transition-group';

const DEFAULT_DURATION = 300;

const out = { opacity: 0, transform: 'translateY(-30px)' };
const transitionStyles = {
  exited: out,
  entering: out,
  exiting: out,
  entered: { opacity: 1, transform: 'none' }
};

type Props = {
  className: String,
  in: Boolean,
  children: React.CElement
};

export default function Fade({
  in: inProp,
  onExited,
  children,
  duration = DEFAULT_DURATION,
  style = {},
  ...rest
}: Props) {
  return (
    <Transition
      in={inProp}
      mountOnEnter
      unmountOnExit
      enter
      appear
      exit
      timeout={{
        enter: 50,
        exit: duration
      }}>
      {state => (
        <div
          {...rest}
          style={{
            ...style,
            transition: `opacity ${duration}ms cubic-bezier(0.4, 0.0, 0.2, 1), transform ${duration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
            ...transitionStyles[state]
          }}>
          {children}
        </div>
      )}
    </Transition>
  );
}
